import React from "react";

import { StatusBanner } from "@/components/feature/StatusBanner";

const AppointmentUpdateSuccess = () => (
  <StatusBanner tone="success" title="Termin aktualisiert" className="mt-[1.2rem]">
    Die Änderungen wurden übernommen. Bitte schliessen Sie die Terminerstellung mit „Senden" ab.
  </StatusBanner>
);

export default AppointmentUpdateSuccess;
